class Registerform extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.email = this.querySelector('[name="customer[email]"]');
        this.confirmEmail = this.querySelector('#RegisterForm-confirm-email');
        this.password = this.querySelector('[name="customer[password]"]');
        this.confirmPassword = this.querySelector('#RegisterForm-password-validate');
        this.firstName = this.querySelector('[name="customer[first_name]"]');
        this.lastName = this.querySelector('[name="customer[last_name]"]');
        // this.phone = this.querySelector('#phone-number');
        this.birthday = this.querySelector('#MyAccount-dob');
        // this.input_acceptMarketing = this.querySelector('input[name="customer[accepts_marketing]"]');
        // this.smsConsentCheckbox = this.querySelector('#accept-marketing');
        this.privacyConsent = this.querySelector('#privacy_consent');
        this.errorMessage = this.querySelector(".form__message.custom_error");
        this.content = this.querySelector(".content_wrapper");
        this.promo = this.querySelector(".custom_success");
        this.submit = this.querySelector("#submit-button");
        // this.togglePasswordButton = this.querySelector('#toggle-password');
        // this.toggleIcon = this.querySelector('#toggle-icon');
        this.errorSummary = this.querySelector('#error-summary');

        // Birthday settings from data attributes
        this.birthdayContainer = this.querySelector('#birth-date-container');
        this.isBirthdayRequired = this.birthdayContainer?.dataset.isBirthdayRequired === 'true';
        this.enableBirthdayValidation = this.birthdayContainer?.dataset.enableBirthdayValidation === 'true';
        this.minimumAgeRequired = parseInt(this.birthdayContainer?.dataset.minimumAgeRequired) || 18;
    }

    connectedCallback() {
        if (this.submit) {
            this.submit.addEventListener("click", (e) => this.onSubmit(e));
        }

        // if (this.togglePasswordButton) {
        //     this.togglePasswordButton.addEventListener('click', () => this.togglePasswordVisibility());
        // }

        if (this.formSubmitted()) {
            this.hideForm();
        }
    }

    formSubmitted() {
        const params = new URLSearchParams(window.location.search);
        return params.get("customer_posted") === "true";
    }

    hideForm() {
        this.content.style.display = "none";
    }

    showPromo() {
        this.promo.style.display = "flex";
    }

    hideMailError() {
        if (this.errorMessage) {
            this.errorMessage.style.display = "none";
        }
    }

    showMailError() {
        if (this.errorMessage) {
            this.errorMessage.style.display = "flex";
        }
    }

    // isValidPhoneNumber(phone) {
    //     const phoneRegex = /^\d{10}$/;
    //     return phoneRegex.test(phone);
    // }

    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    isValidPassword(password) {
        const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
        return passwordRegex.test(password);
    }

    isValidBirthday(birthdate) {
        // If field is empty
        if (!birthdate || birthdate.length === 0) {
            // Empty is valid only if field is not required
            return !this.isBirthdayRequired;
        }

        // If user entered a date, validate it regardless of required status
        const today = new Date();
        const birth = new Date(birthdate);

        // Check if date is valid
        if (isNaN(birth.getTime())) {
            return false;
        }

        // Check if date is not in the future
        if (birth > today) {
            return false;
        }

        // If age validation is disabled, any valid date is acceptable
        if (!this.enableBirthdayValidation) {
            return true;
        }

        // Calculate age
        let age = today.getFullYear() - birth.getFullYear();
        const monthDiff = today.getMonth() - birth.getMonth();

        // Adjust age if birthday hasn't occurred yet this year
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
            age--;
        }

        // Verify age meets minimum requirement
        return age >= this.minimumAgeRequired;
    }

    showErrorIcon(field) {
        const errorIcon = field.parentElement.querySelector('.error-icon');
        if (errorIcon) {
            errorIcon.style.display = 'block';
        }
    }

    updateErrorSummary(errors) {
        if (errors.length > 0) {
            this.errorSummary.innerHTML = `
                <ul class="visually-hidden">
                    ${errors.map(error => `<li>${error}</li>`).join('')}
                </ul>
            `;
            this.errorSummary.classList.remove('visually-hidden');
            this.errorSummary.setAttribute('role', 'alert');
            this.errorSummary.focus();
        } else {
            this.errorSummary.classList.add('visually-hidden');
            this.errorSummary.innerHTML = '';
        }
    }

    // validateField(field, validator, errorMessageElement) {
    //     const errorMessage = errorMessageElement.dataset.errorMessage;
    //     if (!validator(field.value.trim())) {
    //         errorMessageElement.textContent = errorMessage;
    //         field.closest('.fieldinput').classList.add('tw-error-border');
    //         field.setAttribute("aria-invalid", "true");
    //     } else {
    //         errorMessageElement.textContent = '';
    //         field.closest('.fieldinput').classList.remove('tw-error-border');
    //         field.removeAttribute("aria-invalid");
    //     }
    // }

    validateField(field, validator, errorMessageElement) {
        const errorMessage = errorMessageElement.dataset.errorMessage;
        const textField = field.closest('arn-text-field');

        if (!validator(field.value.trim())) {
            errorMessageElement.textContent = errorMessage;
            if (textField) {
                textField.classList.add('tw-arn-textfield-error');
            }
            field.setAttribute("aria-invalid", "true");
        } else {
            errorMessageElement.textContent = '';
            if (textField) {
                textField.classList.remove('tw-arn-textfield-error');
            }
            field.removeAttribute("aria-invalid");
        }
    }


    onSubmit(e) {
        e.preventDefault();
        this.hasSubmitted = true;
        let isValid = true;
        let errors = [];

        this.querySelectorAll('.tw-error-message').forEach(el => el.textContent = '');
        this.querySelectorAll('arn-text-field').forEach(el => {
            el.classList.remove('tw-arn-textfield-error');
            el.querySelector("input")?.removeAttribute("aria-invalid");
        });

        const fields = [
            { field: this.firstName, errorElement: this.querySelector('#first-name-error'), validator: val => val.length > 0 },
            { field: this.lastName, errorElement: this.querySelector('#last-name-error'), validator: val => val.length > 0 },
            { field: this.email, errorElement: this.querySelector('#email-error'), validator: val => this.isValidEmail(val) },
            { field: this.confirmEmail, errorElement: this.querySelector('#confirm-email-error'), validator: val => val === this.email.value.trim() },
            // { field: this.phone, errorElement: this.querySelector('#phone-error'), validator: val => this.isValidPhoneNumber(val) || !this.smsConsentCheckbox.checked },
            // { field: this.birthday, errorElement: this.querySelector('#birthday-error'), validator: val => val.length > 0 },
            { field: this.birthday, errorElement: this.querySelector('#birthday-error'), validator: val => this.isValidBirthday(val) },
            { field: this.password, errorElement: this.querySelector('#password-error'), validator: val => this.isValidPassword(val) },
            { field: this.confirmPassword, errorElement: this.querySelector('#confirm-password-error'), validator: val => val === this.password.value.trim() },
            { field: this.privacyConsent, errorElement: this.querySelector('#privacy-consent-error'), validator: () => this.privacyConsent.checked === true }
        ];


        fields.forEach(({ field, errorElement, validator }) => {
            errorElement?.classList.add('tw-hidden');
            const value = field.type === 'checkbox' ? field : field.value.trim();
            // console.log(`Validating field: ${field.name}, value: ${value}, isValid: ${validator(value)}`);
            if (!validator(value)) {
                isValid = false;
                errorElement.classList.remove('tw-hidden');
                errors.push(errorElement.dataset.errorMessage);
                this.validateField(field, validator, errorElement);
                if (!field.hasEventListener) {
                    field.addEventListener('input', () => {
                        if (this.hasSubmitted) {
                            this.validateField(field, validator, errorElement);
                        }
                    });
                    field.hasEventListener = true;
                }
            }
        });

        this.updateErrorSummary(errors);
        if (isValid) {
            this.form.submit();
            localStorage.setItem('is-account-new', true);
            this.saveCustomerData();
        }
    }

    saveCustomerData() {
        const fdata = new FormData(this.form);
        const data = [{
            e: fdata.get("customer[email]"),
            p: fdata.get("customer[password]")
        }]
        const encodedString = btoa(JSON.stringify(data))

        localStorage.setItem('c_profile', encodedString)
    }
}

customElements.define("register-form", Registerform);